const { VITE_CATALOG_API } = import.meta.env;

/**
 * The full catalog dataset list the nextgen project UI reads to resolve a
 * project's attached dataset ids to display records. Exported as a single
 * source of truth so SWR cache revalidations key-match the fetch exactly —
 * a mismatch would silently fail to refresh.
 */
export const catalogDatasetsListUrl = `${VITE_CATALOG_API}/datasets?offset=0&limit=1000&sort_by=title&sort_order=asc`;
